document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".tab-button");
  const secondBanners = document.querySelectorAll(".split-banner-second-image");

  function updateSecondBanner(collection) {
    secondBanners.forEach((img) => {
      img.style.display =
        img.dataset.collection === collection ? "block" : "none";
    });
  }

  tabButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const collection = this.dataset.collection;
      updateSecondBanner(collection);

      // update URL param
      const newUrl = new URL(window.location);
      newUrl.searchParams.set("flag", collection);
      window.history.replaceState(null, "", newUrl);
    });
  });

  // load banner if URL has flag
  const urlParams = new URLSearchParams(window.location.search);
  const flag = urlParams.get("flag");
  if (flag) updateSecondBanner(flag);
});
